<template>
	<h2 class="page-title">{{ title }}</h2>
</template>

<script>
export default {
	props: {
		title: String,
	},
};
</script>

<style>
.page-title {
	color: #38424d;
	font-weight: 700;
	font-size: 1.7em;
}
</style>
